import ComunicationsService from './ComunicationsService'

export default ComunicationsService
